export default __webpack_public_path__ + "static/media/execute_error_exams.8ff5c786.png";